import { Component } from "react"

/* Components */
import { SVG } from "../components"

/* Components */
import { CHOICE } from "../constants/status"

/* Constants */
import { utils } from "../constants"


/* Widget Result */
class Result extends Component {

    render = () => {

        /* Fields */
        const { result, status, currency } = this.props

        /* Check */
        if (!result || status === CHOICE) {
            return
        }

        return (
            <div className="mpb--result-container">

                <div className={`mpb--result mpb--result-win-${utils.check(result.win, "")}`}>
                    <div className="mpb--result-final">{utils.check(result.win, "")}</div>
                </div>

                {parseFloat(result.total) > 0 &&
                    <div className="mpb--result-win">
                        <div className="mpb--result-win-left">
                            <SVG type="result-win-left" />
                        </div>
                        <div className="mpb--result-win-center">
                            <div className="mpb--result-win-center-text">Вы выиграли</div>
                            <div className="mpb--result-win-center-value">{utils.convertor(result.total, currency)}</div>
                        </div>
                        <div className="mpb--result-win-right">
                            <SVG type="result-win-right" />
                        </div>
                    </div>
                }

            </div>
        )
    }

}

export default Result